import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText, Shield, Truck, CreditCard, AlertTriangle, Scale, Clock, RefreshCw, Lock, MapPin, Wrench, Ban } from 'lucide-react';

const LOGO_WHITE = "https://customer-assets.emergentagent.com/job_a85f478b-763e-4b7e-9f54-0dbb5a37a168/artifacts/fk4lgbat_Logo%20Phocea%20Rent.png";

const CGVPage = () => {
  const currentDate = new Date().toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });

  const sections = [
    {
      icon: FileText,
      title: "Article 1 – Objet",
      content: `Les conditions générales de location décrites ci-après détaillent les droits et obligations de l'entreprise Phocea Rent® et de ses clients dans le cadre de la location de l'ensemble des biens et matériels proposés sur la boutique Phocea Rent®.

Toute prestation accomplie par la société Phocea Rent® implique l'adhésion sans réserve du client aux présentes conditions générales de location.`
    },
    {
      icon: Shield,
      title: "Article 2 – Présentation des biens loués",
      content: `Les caractéristiques des biens proposés à la location sont présentées dans les rubriques respectives de chaque catégorie de notre site. Les photographies n'entrent pas dans le champ contractuel. La responsabilité de la société Phocea Rent® ne peut être engagée si des erreurs s'y sont introduites. Tous les textes et images présentés sur le site de la société Phocea Rent® sont réservés, pour le monde entier, au titre des droits d'auteur et de propriété intellectuelle ; leur reproduction, même partielle, est strictement interdite.

Les photographies et graphismes des catalogues et des biens proposés à la location ne sont qu'indicatifs et n'engagent nullement le bailleur. Au cas où un fournisseur modifie un produit, la représentation graphique de celui-ci ne saurait engager la responsabilité du bailleur ni même affecter la validité de la location.

**Choix des biens** : le client ayant pris connaissance des biens et de leurs caractéristiques, commercialisés par www.phocearent.fr, a sous sa seule responsabilité et en fonction de ses besoins tels qu'il les a préalablement déterminés avant toute commande, porté son choix sur le ou les biens faisant l'objet de sa commande. En outre, le client connaissant seul les matériels, logiciels, configurations et autres qu'il utilise, est seul juge de la compatibilité des biens loués avec ceux utilisés par lui. Il appartient exclusivement au client, s'il ne s'estime pas suffisamment compétent, de se faire assister d'un conseil.`
    },
    {
      icon: Clock,
      title: "Article 3 – Durée de validité des offres de location",
      content: `Les biens sont proposés à la location dans la limite des stocks disponibles. En cas de commande d'un bien devenu indisponible, le client sera informé de cette indisponibilité dans les meilleurs délais.`
    },
    {
      icon: CreditCard,
      title: "Article 4 – Prix des loyers",
      content: `Chaque page des biens de notre site indique les prix en euros toutes taxes comprises (TTC). Le montant des éventuels frais de livraison ou autres frais annexes apparaît sur l'écran à la fin de la sélection des différents biens par le client.

La société Phocea Rent® se réserve le droit de modifier ses prix à tout moment mais les biens commandés sont facturés au tarif en vigueur lors de l'enregistrement de la commande.

Les tarifs proposés comprennent les rabais et ristournes que l'entreprise Phocea Rent® serait amenée à octroyer compte tenu de ses résultats ou de la prise en charge par le client de certaines prestations.

Aucun escompte ne sera accordé en cas de paiement anticipé.`
    },
    {
      icon: FileText,
      title: "Article 5 – Commande",
      content: `À partir du moment où le client a enregistré sa commande en validant le paiement, il est considéré comme ayant accepté en connaissance de cause et sans réserve les présentes conditions générales de location, les prix, durées et modalités de location des biens proposés à la location et commandés.

Avant cette validation, il est systématiquement proposé au client de vérifier chacun des éléments de sa commande ; il peut ainsi corriger ses erreurs éventuelles.

La société Phocea Rent® confirme la commande par courrier électronique ; cette information reprend notamment tous les éléments de la commande.

Les données enregistrées par la société Phocea Rent® constituent la preuve de la nature, du contenu et de la date de la commande. Celle-ci est archivée par la société Phocea Rent® dans les conditions et les délais légaux ; le client peut accéder à cet archivage en contactant le service Relations Clients.`
    },
    {
      icon: CreditCard,
      title: "Article 6 – Modalités de paiement",
      content: `Le règlement des commandes s'effectue par Carte Bancaire, par virement bancaire, par PayPal à la demande du client, ou par prélèvement automatique selon la formule souscrite.

Lors de l'enregistrement de la commande, le client devra verser le montant indiqué à la commande, comprenant notamment le premier loyer mensuel ainsi que le dépôt de garantie lorsqu'il est exigé.

Le loyer est payable d'avance, mensuellement, par prélèvement automatique, sauf conditions particulières convenues entre les parties.

Toutes les factures doivent être réglées à leur échéance. Tout retard de paiement par rapport à la date d'échéance stipulée sur la facture pourra entraîner des poursuites judiciaires de notre part.

En cas de retard de paiement, une pénalité de retard au taux de 4 % sera exigible de plein droit, sans préjudice de toute autre action.

Une indemnité forfaitaire de 40 euros par échéance impayée pourra être exigée, ainsi qu'une pénalité complémentaire de 10 % des sommes impayées.

Le défaut de paiement d'une seule échéance pourra entraîner la résiliation du contrat de location dans les conditions prévues aux présentes.`
    },
    {
      icon: RefreshCw,
      title: "Article 7 – Durée de location – Reconduction – Résiliation",
      content: `Le contrat de location est conclu pour une durée minimale de **un (1) mois** à compter de la date de mise à disposition des biens. Il est renouvelable par tacite reconduction pour des périodes successives de un (1) mois, sauf résiliation.

Tout mois entamé est intégralement dû.

À l'échéance de la durée initiale ou d'une période de reconduction, chacune des parties peut résilier le contrat en respectant un préavis de **quinze (15) jours**. Le client pourra effectuer cette demande notamment par l'intermédiaire de la plateforme de réservation en ligne mise à disposition par le bailleur dans la rubrique « résiliation ».

La résiliation prend effet à l'issue du préavis. Toute demande de restitution devra être formulée au moins quinze (15) jours avant la fin du mois contractuel souhaité. À défaut de respect de ce délai, le mois suivant sera automatiquement facturé et débité.`
    },
    {
      icon: Truck,
      title: "Article 8 – Livraison – exploitation – restitution",
      content: `Tout bien loué est livré sans garantie absolue quant aux délais, sous réserve de disponibilité des stocks et des conditions logistiques.

Les biens seront livrés au client à l'adresse convenue lors de la commande, en bon état apparent. Les risques sont transférés au client à compter de la remise des biens au transporteur. Le contrôle fonctionnel devra être effectué dans un délai de 48 heures suivant la réception.

Le client est tenu de vérifier, en présence du transporteur ou du prestataire, l'état de l'emballage et le contenu de la marchandise à la livraison.

Dans l'hypothèse où le client aurait un quelconque doute de quelque nature que ce soit sur l'état ou le contenu de son colis, il est tenu :
– d'appliquer la procédure de chaque transporteur (UPS, DHL, DPD, FedEx/TNT, Colissimo ou DASHER) notamment en signalant les dommages dus, toutes réclamations et réserves, et de refuser la marchandise en émettant immédiatement un constat d'anomalie auprès du préposé du transporteur ;
– de signaler ces incidents à Phocea Rent® par lettre recommandée avec demande d'avis de réception à l'adresse indiquée aux présentes, dans un délai de 7 jours à compter du refus de la marchandise par le client, en exposant lesdites réclamations ou réserves.

Les frais d'expédition sont à la charge du client. Toutefois, une prise en charge partielle ou totale des frais de livraison peut être appliquée pour certaines zones géographiques, notamment dans le département des Bouches-du-Rhône, selon les conditions commerciales en vigueur au moment de la commande.

Les biens proposés à la location sont des produits d'occasion. À ce titre, ils peuvent présenter des traces d'usure esthétique, notamment sur les écrans, sans que cela n'affecte leur bon fonctionnement. Ces marques d'usure ne pourront en aucun cas être considérées comme un défaut ou donner lieu à réclamation.

Les restitutions des biens doivent impérativement être effectuées pendant les horaires d'ouverture de l'agence du bailleur. Toute restitution en dehors de ces horaires devra faire l'objet d'un accord préalable et pourra entraîner des frais supplémentaires.

Faute de respect de la procédure exposée ci-dessus, aucune réclamation du client ne pourra être acceptée.

Le client s'engage à exploiter le bien loué exclusivement dans le cadre de son activité professionnelle.

À la restitution, un état des biens sera établi. Toute dégradation constatée sera présumée imputable au client, sauf preuve contraire.

Les frais d'expédition initiale peuvent être pris en charge par le bailleur selon l'offre souscrite. Les frais de retour restent à la charge du client.

En cas de dégradation, il pourra être facturé notamment :
– 19 € HT par LED endommagée ;
– 19 € HT par circuit imprimé remplacé.`
    },
    {
      icon: Lock,
      title: "Article 9 – Dépôt de garantie",
      content: `Lors de la signature du contrat ou de la validation de la commande, le client verse à Phocea Rent® un dépôt de garantie dont le montant est indiqué au moment de la commande. Ce dépôt de garantie ne produit aucun intérêt.

Le dépôt de garantie garantit l'exécution par le client de toutes ses obligations contractuelles, notamment :
– le paiement des loyers, charges et accessoires ;
– la restitution du matériel en bon état d'usage, compte tenu de la vétusté normale ;
– la réparation des dégradations constatées ;
– l'indemnisation en cas de non-restitution du matériel.

Le dépôt de garantie sera restitué au client dans un délai maximum de **30 jours** suivant la restitution effective des biens et l'apurement de toutes sommes dues, déduction faite, le cas échéant, des loyers impayés, frais de remise en état, frais de réparation ou de remplacement.`
    },
    {
      icon: Shield,
      title: "Article 10 – Réserve de propriété",
      content: `Les biens loués demeurent la propriété exclusive de Phocea Rent® pendant toute la durée du contrat. Les loyers versés constituent exclusivement la contrepartie de la mise à disposition temporaire des biens. Aucun transfert de propriété ne pourra intervenir au profit du client.

Le présent contrat est conclu exclusivement à titre de location. Aucune option d'achat n'est consentie au client.`
    },
    {
      icon: Ban,
      title: "Article 11 – Interdiction de cession et de sous-location",
      content: `Le client s'interdit toute cession du présent contrat sans l'accord écrit préalable de Phocea Rent®.

La sous-location des biens est interdite sans accord écrit préalable du bailleur.

Toutefois, l'installation temporaire des biens sur le site d'un client final est autorisée dans le cadre de prestations événementielles réalisées par le client dans le cadre de son activité professionnelle.`
    },
    {
      icon: Shield,
      title: "Article 12 – Assurance",
      content: `Le client s'engage à souscrire une assurance couvrant les biens loués contre les risques de vol, incendie, dégâts des eaux, casse accidentelle et transport. Les biens doivent être assurés pour leur valeur de remplacement.

La livraison peut être conditionnée à la réception par Phocea Rent® d'une attestation d'assurance en cours de validité, notamment d'une assurance RC Professionnelle.

En cas de perte, vol ou destruction totale, le client devra indemniser Phocea Rent® à hauteur de 100 % de la valeur de remplacement des biens.`
    },
    {
      icon: Wrench,
      title: "Article 13 – Assistance technique – service après-vente",
      content: `Pour toute information, question ou réclamation, le client peut s'adresser du lundi au vendredi, de 9 h à 18 h, au service Relations Clients de la société.

**Adresse** : 65 Avenue Jacqueline Auriol, Bâtiment 5, 13700 Marignane
**Tél** : 04 86 68 33 55
**E-mail** : contact@phocearent.fr
**RCS** : 820 956 076

Toute demande d'assistance technique pourra faire l'objet d'une facturation au tarif de 99 € HT par heure. Toute heure commencée est due.`
    },
    {
      icon: AlertTriangle,
      title: "Article 14 – Droit de rétractation",
      content: `Les biens proposés par Phocea Rent® sont destinés à un usage exclusivement professionnel. En conséquence, le client professionnel ne bénéficie pas du droit de rétractation prévu par le Code de la consommation, sauf dispositions légales impératives contraires applicables à sa situation.

Dans l'hypothèse exceptionnelle où un droit de rétractation serait applicable, les biens devront impérativement être restitués dans leur état d'origine, complets, avec accessoires, notices et emballages, et en parfait état d'usage. Tout bien incomplet, abîmé, endommagé ou dont l'emballage d'origine aura été détérioré pourra donner lieu à retenue, facturation complémentaire ou refus de remboursement.

En cas de restitution anticipée, les frais de retour restent à la charge du client.`
    },
    {
      icon: Shield,
      title: "Article 15 – Garantie et état du matériel",
      content: `Les biens loués sont remis en bon état de fonctionnement. Toute réclamation relative à leur état ou à leur fonctionnement doit être formulée dans le délai de 48 heures suivant leur réception.

Tout retour ou intervention doit faire l'objet d'un accord préalable de Phocea Rent®. Aucun retour ne sera accepté sans autorisation préalable.

Le client est tenu d'utiliser les biens conformément à leur destination et dans des conditions normales d'utilisation.

Ne sont notamment pas couverts :
– l'utilisation anormale ou non conforme des biens ;
– les défauts et leurs conséquences dus à l'intervention du client ou d'un tiers non agréé ;
– les dégradations dues à un choc, une mauvaise manipulation, une négligence ou un défaut de surveillance.`
    },
    {
      icon: MapPin,
      title: "Article 16 – Dispositif de localisation",
      content: `Afin d'assurer la protection des biens contre le vol, la perte, la disparition ou leur non-restitution en cas d'impayé ou de résiliation du contrat, les biens peuvent être équipés d'un dispositif de localisation électronique. Le client reconnaît être informé de cet équipement et s'engage à ne pas tenter de le neutraliser.

Ce dispositif :
– ne permet aucune captation sonore, visuelle ou surveillance des personnes ;
– n'a pour finalité exclusive que la protection et la récupération des biens ;
– ne fait l'objet d'aucune exploitation commerciale des données collectées.

Les données de localisation sont traitées par le bailleur sur le fondement de son intérêt légitime à la protection de ses actifs, conformément au Règlement (UE) 2016/679 (RGPD) et à la loi Informatique et Libertés. Elles sont conservées pendant la durée du contrat et supprimées dans un délai maximum de 30 jours suivant la restitution effective des biens.

Toute tentative de neutralisation du dispositif pourra entraîner l'application des sanctions prévues aux présentes conditions.`
    },
    {
      icon: Scale,
      title: "Article 17 – Responsabilité",
      content: `Les biens proposés par www.phocearent.fr sont conformes à la législation française en vigueur. Phocea Rent® ne pourra être tenue pour responsable de l'inexécution du contrat en cas d'indisponibilité des biens, de force majeure, de perturbation ou grève totale ou partielle notamment des services postaux, transporteurs, moyens de transport et/ou communications.

Phocea Rent® ne pourra être tenue pour responsable de tous dommages indirects, pertes d'exploitation, pertes de chiffre d'affaires, pertes de données ou tout autre préjudice immatériel qui pourraient survenir du fait de la location des biens.

L'impossibilité totale ou partielle d'utiliser les biens, en raison notamment d'une incompatibilité de matériel, ne peut engager la responsabilité de Phocea Rent® ni donner lieu à aucun dédommagement ou remboursement.

En tout état de cause, la responsabilité du bailleur est limitée au montant des loyers perçus au titre du mois concerné.`
    },
    {
      icon: AlertTriangle,
      title: "Article 18 – Sanctions pour inexécution",
      content: `Le contrat pourra être résilié immédiatement en cas de non-paiement, manquement aux obligations d'assurance, dégradation des biens, tentative de neutralisation du dispositif de localisation ou plus généralement en cas de manquement grave du client à ses obligations contractuelles, après mise en demeure restée sans effet pendant un délai de 8 jours.

Cette résiliation ne fera pas obstacle au paiement des loyers échus, des pénalités, des frais engagés et de toute indemnisation due au bailleur.`
    },
    {
      icon: Lock,
      title: "Article 19 – Informatique et Libertés",
      content: `Les informations collectées par Phocea Rent® lors de toute commande du client sont nécessaires pour la gestion de sa commande, de son contrat de location et de la relation commerciale par Phocea Rent® et ses partenaires commerciaux.

Conformément à la réglementation applicable en matière de protection des données personnelles, le client dispose d'un droit d'accès, de rectification, d'opposition, de suppression et, le cas échéant, de limitation du traitement des données le concernant auprès de Phocea Rent®.

En acceptant les présentes conditions générales de location, le client autorise Phocea Rent® à le contacter via WhatsApp, SMS, Messenger, e-mail ou téléphone dans le cadre de la gestion de son contrat, du suivi commercial ou de l'information sur les offres de www.phocearent.fr.

Par l'intermédiaire de Phocea Rent®, le client peut être amené à recevoir des propositions commerciales d'autres organismes ou entreprises. S'il ne souhaite pas recevoir ces propositions, il peut en informer Phocea Rent® par courrier ou par e-mail à contact@phocearent.fr.`
    },
    {
      icon: Scale,
      title: "Article 20 – Litiges",
      content: `Toutes contestations relatives aux présentes conditions générales de location et aux contrats conclus en application de celles-ci seront soumises à la compétence du tribunal compétent.

Les présentes conditions générales de location sont régies par le droit français.`
    }
  ];

  return (
    <div className="min-h-screen bg-black">
      {/* Header */}
      <header className="bg-black/95 backdrop-blur-sm border-b border-slate-800 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2">
              <img src={LOGO_WHITE} alt="Phocea Rent" className="h-10 w-auto" />
            </Link>
            <Link 
              to="/" 
              className="flex items-center gap-2 text-slate-400 hover:text-[#DFFF00] transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              Retour au site
            </Link>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="py-16 bg-gradient-to-b from-slate-900/50 to-black">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center gap-2 bg-[#DFFF00]/10 border border-[#DFFF00]/30 rounded-full px-4 py-2 mb-6">
            <FileText className="w-4 h-4 text-[#DFFF00]" />
            <span className="text-[#DFFF00] text-sm font-medium">Document légal</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Conditions générales de location
          </h1>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            Location d'écrans LED professionnels – Phocea Rent®
          </p>
          <p className="text-slate-500 text-sm mt-4">
            Dernière mise à jour : {currentDate}
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Articles */}
          <div className="space-y-8">
            {sections.map((section, index) => (
              <article 
                key={index}
                data-testid={`cgv-article-${index + 1}`}
                className="bg-slate-900/30 border border-slate-800 rounded-2xl overflow-hidden"
              >
                <div className="bg-slate-800/50 px-6 py-4 flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl bg-[#DFFF00]/10 flex items-center justify-center">
                    <section.icon className="w-5 h-5 text-[#DFFF00]" />
                  </div>
                  <h2 className="text-lg font-semibold text-white">{section.title}</h2>
                </div>
                <div className="px-6 py-5">
                  <div 
                    className="text-slate-400 leading-relaxed whitespace-pre-line prose prose-invert prose-sm max-w-none
                      [&_strong]:text-white [&_strong]:font-semibold"
                    dangerouslySetInnerHTML={{ 
                      __html: section.content
                        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
                        .replace(/\n/g, '<br/>')
                    }}
                  />
                </div>
              </article>
            ))}
          </div>

          {/* Contact Box */}
          <div className="mt-12 bg-gradient-to-r from-[#DFFF00]/10 to-transparent border border-[#DFFF00]/30 rounded-2xl p-6">
            <h3 className="text-lg font-semibold text-white mb-3">Une question sur nos conditions générales ?</h3>
            <p className="text-slate-400 mb-4">
              Notre équipe est à votre disposition pour toute question relative aux présentes 
              conditions générales de location.
            </p>
            <div className="flex flex-wrap gap-4">
              <a 
                href="mailto:contact@phocearent.fr" 
                data-testid="cgv-contact-btn"
                className="inline-flex items-center gap-2 bg-[#DFFF00] text-black px-4 py-2 rounded-lg font-medium hover:bg-[#c8e600] transition-colors"
              >
                Nous contacter
              </a>
              <Link 
                to="/" 
                data-testid="cgv-back-home-btn"
                className="inline-flex items-center gap-2 bg-slate-800 text-white px-4 py-2 rounded-lg font-medium hover:bg-slate-700 transition-colors"
              >
                Retour à l'accueil
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Footer Mini */}
      <footer className="py-8 border-t border-slate-800">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-500">
            <p>© {new Date().getFullYear()} Phocea Rent. Tous droits réservés.</p>
            <div className="flex gap-6">
              <Link to="/mentions-legales" className="hover:text-[#DFFF00] transition-colors">
                Mentions légales
              </Link>
              <Link to="/confidentialite" className="hover:text-[#DFFF00] transition-colors">
                Confidentialité
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default CGVPage;
